'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { useQuery } from '@tanstack/react-query'
import { StockExpiryBanner } from 'src/app/(main)/_components/stock-expiry-banner'
import { getSellerQueries } from 'src/deprecated/api/seller-queries'
import { useUser } from 'src/deprecated/contexts/User'

export function StockExpiryBannerWrapper() {
  const { sellerStocklistType } = useUser()

  const canaryClient = useCanaryClient()
  const sellerQueries = getSellerQueries(canaryClient)
  const { data } = useQuery(sellerQueries.stats())
  const stocklistExpiresAt = data?.originalData.stocklistExpiresAt ?? null

  return (
    <StockExpiryBanner
      sellerStocklistType={sellerStocklistType}
      stocklistExpiresAt={stocklistExpiresAt}
    />
  )
}
